export interface AppSliceState {
  isMenu: boolean;
  isIntro: boolean;
  currentSection: number;
}
export const initialState: AppSliceState = {
  isMenu: false,
  isIntro: true,
  currentSection: 0
};